import React from "react";
import { t } from "@lingui/macro";
import { useHistory } from "react-router-dom";
import { i18n } from "idc-ui-react";
// Fabric Styling
import { AnimationStyles } from "@uifabric/styling";
// Fluent UI
import { Stack, Text, Icon } from "@fluentui/react";

const ReturnLink = () => {
  const history = useHistory();

  return (
    <Stack
      onClick={() => history.push("/")}
      horizontal
      verticalAlign="center"
      styles={{
        root: {
          color: "rgb(0, 120, 212)",
          fontSize: "20px",
          marginBottom: "8px",
          cursor: "pointer"
        }
      }}
      tokens={{ childrenGap: 4 }}
    >
      <Icon iconName="NavigateBack" />
      <Text variant="large">{i18n._(t`Back to Dashboard`)}</Text>
    </Stack>
  );
};

const Section = ({
  hero,
  returnLink = false,
  text,
  children,
  slide = "left"
}) => (
  <Stack
    as="section"
    styles={{
      root: [
        {
          position: "relative",
          margin: "auto",
          marginBottom: "30px",
          width: "84%",
          maxWidth: "1128px"
        },
        hero && [{ marginTop: "40px" }]
      ]
    }}
    className={
      slide === "right"
        ? AnimationStyles.slideRightIn40
        : AnimationStyles.slideLeftIn40
    }
  >
    {returnLink && <ReturnLink />}
    {text && (
      <Text
        styles={{ root: { marginBottom: "20px" } }}
        variant={hero ? "xxLargePlus" : "xLarge"}
      >
        {text}
      </Text>
    )}
    {children}
  </Stack>
);

export default Section;
